import { useQuery } from '@tanstack/react-query'
import { ChallengeService } from '@duck/api-definitions'
import { apis } from '@/modules/apiClients'
import { useAuth } from './useAuth'
import { queryClient } from '@/modules/queryClient'

export const ongoingChallengesQueryKeys = {
  all: () => ['ongoing-challenges'] as const,
  user: () => ['ongoing-challenges', 'user'] as const
}

const fetchOngoingChallenges = async (): Promise<ChallengeService.ChallengesResponse> => {
  try {
    const response = await apis.challengeService.getOngoingChallenges()
    return response.data
  } catch (error) {
    return {
      availableChallenges: [],
      availableAssignments: [],
      count: 0,
    }
  }
}

export const useOngoingChallenges = () => {
  const { isAuthenticated } = useAuth()
  const query = useQuery({
    queryKey: ongoingChallengesQueryKeys.user(),
    queryFn: fetchOngoingChallenges,
    enabled: isAuthenticated,
    staleTime: 30 * 60 * 1000, // 30 minutes - shorter than default since challenges can change frequently
  })

  return {
    challenges: query.data?.availableChallenges ?? [],
    assignments: query.data?.availableAssignments ?? [],
    count: query.data?.count ?? 0,
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    clearOngoingChallenges: () => {
      queryClient.removeQueries({ queryKey: ongoingChallengesQueryKeys.all() })
    }
  }
}
